const loadFlightTrafficPrefix = "loadFlightTraffics";
const loadFlightTrafficActionTypes = {
  LOAD: `${loadFlightTrafficPrefix}/LOAD_FLIGHT_TRAFFIC`,
  LOADING: `${loadFlightTrafficPrefix}/LOADING_FLIGHT_TRAFFIC`,
  LOADED: `${loadFlightTrafficPrefix}/LOADED_FLIGHT_TRAFFIC`
};
const loadFlightTraffic = (flightId, workspaceId, managementGroup) => {
  return {
    type: loadFlightTrafficActionTypes.LOAD,
    payload: {
      flightId,
      workspaceId,
      managementGroup
    }
  };
};
const loadingFlightTraffic = (flightId, workspaceId, managementGroup) => {
  return {
    type: loadFlightTrafficActionTypes.LOADING,
    payload: {
      flightId,
      workspaceId,
      managementGroup
    }
  };
};
const loadedFlightTraffic = (flightId, workspaceId, managementGroup, data, error) => {
  return {
    type: loadFlightTrafficActionTypes.LOADED,
    payload: {
      flightId,
      workspaceId,
      managementGroup,
      data,
      error
    }
  };
};
export {
  loadFlightTraffic,
  loadFlightTrafficActionTypes,
  loadedFlightTraffic,
  loadingFlightTraffic
};
//# sourceMappingURL=FlightTraffic.ducks.js.map
